import configureStore, { store } from './store';

export { store };
export default configureStore;
